// @custom — Analytics configuration for first-party visitor tracking.
// The provider switches between counting backends:
//   'local' (default) — keeps captured page views in the browser (in-memory
//                       ring buffer + localStorage) and sends nothing over
//                       the network.
//   'api'   (opt-in)  — posts page views to the product's own
//                       POST /analytics/pageview endpoint.
//   'ga4' | 'gtm' | 'plausible' — forward events to the provider's global
//                       (window.gtag / window.dataLayer.push /
//                       window.plausible) when the provider script is added.
//   'none'            — disables all tracking.
// Changing the provider value (plus adding the provider's script, for the
// third-party ones) is the only step needed to switch providers.

/**
 * @typedef {'none' | 'local' | 'api' | 'ga4' | 'gtm' | 'plausible'} AnalyticsProvider
 */

/** @type {{ provider: AnalyticsProvider, enabled: boolean, debug: boolean, pageviewEndpoint: string, storageKey: string, storageEventsKey: string, cookieConsentRequired: boolean }} */
export const analyticsConfig = {
  /** Which provider is currently active ('local' never touches the network) */
  provider: 'local',
  /** Master toggle — when false, trackPageView/trackEvent are no-ops */
  enabled: true,
  /** Debug mode — exposes window.__analytics (getCapturedEvents) when on */
  debug: false,
  /** POST endpoint the 'api' provider calls */
  pageviewEndpoint: '/analytics/pageview',
  /** localStorage key used to persist the visitor id */
  storageKey: 'cluboria_visitor_id',
  /** localStorage key used to persist the captured page-view ring buffer */
  storageEventsKey: 'cluboria_analytics_events',
  /** Whether the @system cookie consent gate is required (first-party is exempt) */
  cookieConsentRequired: false,
}